import * as t from 'io-ts';
import { LegDynamicType } from './leg';
import { TripStatusDynamicType } from './tripStatus';
import { DateTime } from 'acscp/api/models/customTypes/dateTime';
import { DepartmentType } from 'acscp/api/models/customTypes/department';

export const BookingDynamicType = t.interface({
    id: t.string,
    enquiryId: t.string,
    status: TripStatusDynamicType,
    legs: t.array(LegDynamicType),
    contentIdentifier: t.string,
    read: t.boolean,
    ownedByCurrentUser: t.boolean,
    ownerOfBookingId: t.string,
    ownerOfBookingName: t.string,
    sharedByName: t.union([t.string, t.null]),
    jetCardNo: t.union([t.string, t.null]),
    jetCardContractDate: t.union([DateTime, t.null]),
    jetCardType: t.union([t.string, t.null]),
    createdInCustomerPortal: t.boolean,
    customerId: t.string,
    notesToCustomer: t.union([t.string, t.null]),
    htmlNotesToCustomer: t.union([t.string, t.null]),
    aircraftType: t.union([t.string, t.null]),
    autoPublishedToCustomerPortal: t.boolean,
    enquiryOfficeTelephoneNumber: t.union([t.string, t.null]),
    mainSiteLink: t.union([t.string, t.null]),
    departmentKey: DepartmentType,
    isInAcmiWorkflow: t.boolean,
    leaseType: t.union([t.string, t.null]),
    period: t.union([t.number, t.null]),
    routeNetwork: t.union([t.string, t.null]),
    minGuaranteedBlockHours: t.union([t.string, t.null]),
    cycleRatio: t.union([t.string, t.null]),
});

export type Booking = t.TypeOf<typeof BookingDynamicType>;
